'use strict';

module.exports = /^'?(\d{1,2})$/;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/var/ABBREVIATED_YEAR_REG.js
// module id = 597
// module chunks = 0